import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { selectActiveCompanyId } from "../../../redux/features/user/selectors/userState.selectors";
import { resendEventDeliveryLog } from "../actions/resendEventDeliveryLog";
import { EVENT_DELIVERY_LOG_DETAIL_QUERY_KEY } from "./useGetEventDeliveryLogDetail";
import { EVENT_DELIVERY_LOGS_QUERY_KEY } from "./useGetEventDeliveryLogs";

export const useResendEventDeliveryLog = () => {
  const queryClient = useQueryClient();
  const companyId = useSelector(selectActiveCompanyId);

  return useMutation({
    mutationFn: (logUid: string) => resendEventDeliveryLog(logUid),
    onSuccess: (_data, logUid) => {
      queryClient.invalidateQueries({ queryKey: [EVENT_DELIVERY_LOGS_QUERY_KEY, companyId] });
      queryClient.invalidateQueries({ queryKey: [EVENT_DELIVERY_LOG_DETAIL_QUERY_KEY, companyId, logUid] });
    },
  });
};
